// Mapping between display labels and API values for report styles/personas

export const PERSONAS = [
  {
    label: "Executive Summary",
    value: "Executive",
    version: "v2",
    description: "Ultra-concise, single high-impact conclusion",
  },
  {
    label: "Concise Slide",
    value: "Concise",
    version: "v1",
    description: "Single-slide format with key insights",
  },
];

export const DEFAULT_PERSONA = PERSONAS[0];

export const getPersonaByValue = (value) => {
  const persona = PERSONAS.find((p) => p.value === value);
  if (!persona) throw new Error(`Unknown persona value: ${value}`);
  return persona;
};

export const getPersonaByVersion = (version) => {
  const persona = PERSONAS.find((p) => p.version === version);
  if (!persona) throw new Error(`Unknown persona version: ${version}`);
  return persona;
};
